import { FunctionComponent, useState } from 'react'
import { Alert, Button, Form, Spinner } from 'react-bootstrap'
import { Link } from 'react-router-dom'

import AuthCardLayout from 'components/layout/auth/authCardLayout'
import * as api from '../api.client'
import authLinksCss from 'components/layout/auth/authLinks.module.scss'
import { AppMessage } from '../../../utilities/messages'

const PasswordRecovery: FunctionComponent = () => {
  const [showFormErrors, setShowFormErrors] = useState(false)
  const [appMessage, setAppMessage] = useState<AppMessage>({ show: false })
  const [email, setEmail] = useState<string>('')
  const [recoveringPassword, setRecoveringPassword] = useState(false)

  const recoverPassword = async (event: React.ChangeEvent<HTMLFormElement>) => {
    event.preventDefault()

    const formIsValid = event.currentTarget.checkValidity()

    if (!formIsValid) {
      setShowFormErrors(true)
      return
    }

    setRecoveringPassword(true)

    try {
      await api.recoverPassword(email)

      setAppMessage({
        show: true,
        success: true,
        message: 'Enviamos um email com instruções para redefinir sua senha.',
      })
    } catch (error) {
      setAppMessage({
        show: true,
        success: false,
        message: (error as any).messages.join(', '),
      })
    } finally {
      setRecoveringPassword(false)
    }
  }

  const handleFormChange = ({
    target,
  }: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(target.value)
  }

  return (
    <AuthCardLayout
      title="Redefinir senha"
      subtitle="Informe seu email e enviaremos as instruções para criar uma nova senha."
    >
      {appMessage.show && (
        <Alert variant={appMessage.success ? 'success' : 'danger'}>
          {appMessage.message}
        </Alert>
      )}
      <Form noValidate validated={showFormErrors} onSubmit={recoverPassword}>
        <Form.Group controlId="recovery-email">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            name="email"
            autoComplete="email"
            placeholder="seu@email.com"
            value={email}
            onChange={handleFormChange}
            required
          />
          <Form.Control.Feedback type="invalid">
            Informe um email válido.
          </Form.Control.Feedback>
        </Form.Group>

        <Button
          type="submit"
          size="lg"
          className="w-100 mt-4"
          disabled={recoveringPassword}
        >
          {recoveringPassword && <Spinner size="sm" animation="border" />}
          {recoveringPassword ? 'Processando…' : 'Enviar instruções'}
        </Button>

        <p className={`${authLinksCss.links} ${authLinksCss.center}`}>
          <Link to="/login">← Voltar para o login</Link>
        </p>
      </Form>
    </AuthCardLayout>
  )
}

export default PasswordRecovery
